module.exports = __webpack_public_path__ + "static/22-df6e95c78bff7bf959e639b15a0a9bcf.jpg";